import React, { useContext, useEffect, useState } from 'react';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { useHistory, withRouter, useLocation } from 'react-router';
import { SidebarData } from './SidebarData';
import { FirebaseContext } from '../../../context/firebase';
import { signInSuccess, setRedirect } from '../../../redux/signIn/actions';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssessmentIcon from '@material-ui/icons/Assessment';
import VideocamIcon from '@material-ui/icons/Videocam';
import { connect } from 'react-redux';
import styles from './Sidebar.module.scss';
import { useSidebarStyles } from '../../../muiStyles/Sidebar.mui.js';
import createSessionAppointment from '../../../api/VideoCall/createSessionWithAppointment.api';
import VideoLoader from '../VideoCallLoader/VideoLoader';
import { Grid, Tooltip } from '@material-ui/core';
import { proceedLogOut } from '../../../redux/auth/actions';
import { getProfileSuccess } from '../../../redux/profile/action';
import CompanyImage from '../../../images/companyLogoFull.png';
import glenridgeLogo from '../../../images/glenridgeLogo.png';
import ambriaLogo from '../../../images/ambriaLogo.png';
import { checkRolesAccessibilities } from '../../../utils/checkRolesAccessibilities';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import getCompanies from '../../../api/Layout/getCompanies.api';
import { getPurchasers } from '../../../redux/purchasers/actions';

const Sidebar = (props) => {
	const {
		signInSuccess,
		setRedirect,
		user,
		profileData,
		proceedLogOut,
		getProfileSuccess,
		rolesAccessibilities,
		getPurchasers,
	} = props;
	const { firebase } = useContext(FirebaseContext);
	const [open, setOpen] = useState(false);
	const [drawerHover, setDrawerHover] = useState(false);
	const [loading, setLoading] = useState(false);
	const [disableNavs, setDisableNavs] = useState(false);
	const [companyEl, setCompanyEl] = useState(null);
	const [companies, setCompanies] = useState([]);
	const [companySelected, setCompanySelected] = useState('ambria_aurora');
	const [companyName, setComapnyName] = useState('');
	const history = useHistory();
	const location = useLocation();
	const classes = useSidebarStyles();
	const theme = useTheme();

	useEffect(() => {
		if (open === true) {
			setTimeout(() => {
				handleDrawerClose();
			}, 4000);
		}
	}, [open, drawerHover]);

	useEffect(async () => {
		let companyList = await getCompanies();
		setCompanies(companyList);
	}, []);

	useEffect(() => {
		let result = companies.filter((item) => item.id === companySelected);
		if (result.length > 0) {
			setComapnyName(result[0].companyName);
		}
	}, [companySelected, companies]);

	useEffect(() => {
		getPurchasers();
	}, []);

	const styleDisableBtn = (link) => {
		if (history.location.pathname === link) {
			return { pointerEvents: 'none' };
		}
	};

	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	const handleVideoCall = async () => {
		setLoading(true);

		createSessionAppointment(
			user.email,
			user.displayName,
			user.userType,
			user.phoneNumber,
			user.uid,
			(returned) => setLoading(returned),
			(returned) => setDisableNavs(returned)
		).then((details) =>
			history.push({
				pathname: '/videocall',
				state: {
					detail: details,
				},
			})
		);
	};

	const styleDisableNavs = () => {
		if (disableNavs === true) {
			return { pointerEvents: 'none' };
		}
	};

	const handleCloseCompanyMenu = () => {
		setCompanyEl(null);
	};

	const handleOpenCompanyMenu = (event) => {
		setCompanyEl(event.currentTarget);
	};

	const handleCompanyChange = (id) => {
		setCompanySelected(id);
		handleCloseCompanyMenu();
	};

	return (
		<>
			{loading && <VideoLoader />}
			<div className={styles.sidebar} id='sidebar'>
				<CssBaseline />
				<AppBar
					position='fixed'
					className={clsx(classes.appBar, {
						[classes.appBarShift]: open,
					})}
					color='default'
				>
					<Toolbar className={styles.toolbar}>
						<IconButton
							color='inherit'
							aria-label='open drawer'
							onClick={handleDrawerOpen}
							edge='start'
							className={clsx(classes.menuButton, {
								[classes.hide]: open,
							})}
						>
							<MenuIcon style={{ margin: 7 }} />
						</IconButton>
						<Grid
							container
							display='flex'
							justifyContent='space-between'
						>
							<Grid item className={styles.companyImage}>
								<div className={styles.companyGroup}>
									<img src={ambriaLogo} alt='' />
									{/* <p className={styles.divider}>|</p>
									<Button
										endIcon={<ArrowDropDownIcon />}
										className={styles.companySelector}
										onClick={handleOpenCompanyMenu}
									>
										{companyName}
									</Button>
									<Menu
										anchorEl={companyEl}
										open={Boolean(companyEl)}
										onClose={handleCloseCompanyMenu}
									>
										{companies?.map((company, index) => (
											<MenuItem
												key={index}
												onClick={() =>
													handleCompanyChange(
														company.id
													)
												}
												value={company.id}
											>
												{company.companyName}
											</MenuItem>
										))}
									</Menu> */}
								</div>
							</Grid>
							<Grid item className={styles.small_profile_badge}>
								<div
									className={styles.dropdown_btn_profile}
									style={{
										cursor:
											user.userType === 'client'
												? 'auto'
												: 'pointer',
									}}
									onClick={() => {
										if (user.userType !== 'client') {
											history.push(
												`/profile/${user.uid}`
											);
										}
									}}
								>
									<div className={styles.d_flex}>
										<img
											src={profileData?.profilePicture}
											alt='Profile Picture'
										/>
										<div className={styles.usernameGroup}>
											<div className={styles.username}>
												{profileData?.fullName}
											</div>
											<div className={styles.userType}>
												{profileData?.roleName}
											</div>
										</div>
									</div>
								</div>
							</Grid>
						</Grid>
					</Toolbar>
				</AppBar>
				<Drawer
					variant='permanent'
					className={clsx(classes.drawer, {
						[classes.drawerOpen]: open,
						[classes.drawerClose]: !open,
					})}
					classes={{
						paper: clsx({
							[classes.drawerOpen]: open,
							[classes.drawerClose]: !open,
						}),
					}}
					// onEnter={() => setDrawerHover(true)}
				>
					<div className={classes.toolbar}>
						<IconButton
							onClick={handleDrawerClose}
							className={styles.iconButton}
						>
							{theme.direction === 'rtl' ? (
								<ChevronRightIcon className={styles.m0} />
							) : (
								<ChevronLeftIcon className={styles.m0} />
							)}
						</IconButton>
					</div>

					<List className={styles.listGroup}>
						{SidebarData.map((val, key) => {
							if (
								checkRolesAccessibilities(
									rolesAccessibilities,
									user.userType,
									'sidebar',
									'sidebar',
									val.id
								)
							) {
								if (val.title === 'Dashboard') {
									return (
										<ListItem
											button
											key={key}
											onClick={() => {
												history.push(val.link);
											}}
											className={
												location.pathname === val.link
													? `${styles.active} ${styles.listItem}`
													: `${styles.listItem}`
											}
											style={{ ...styleDisableNavs() }}
										>
											<ListItemIcon
												className={classes.listItemIcon}
											>
												<Tooltip
													title={val.title}
													placement='right'
												>
													{val.icon}
												</Tooltip>
											</ListItemIcon>
											<ListItemText primary={val.title} />
										</ListItem>
									);
								} else if (val.title === 'Video Call') {
									return (
										<ListItem
											button
											key={key}
											onClick={() => {
												handleVideoCall();
											}}
											className={
												location.pathname === val.link
													? `${styles.active} ${styles.listItem}`
													: `${styles.listItem}`
											}
										>
											<ListItemIcon
												className={classes.listItemIcon}
											>
												<Tooltip
													title={val.title}
													placement='right'
												>
													{val.icon}
												</Tooltip>
											</ListItemIcon>
											<ListItemText primary={val.title} />
										</ListItem>
									);
								} else {
									return (
										<ListItem
											button
											key={key}
											onClick={() => {
												history.push({
													pathname: val.link,
												});
											}}
											className={
												location.pathname === val.link
													? `${styles.active} ${styles.listItem}`
													: `${styles.listItem}`
											}
											style={{ ...styleDisableNavs() }}
										>
											<ListItemIcon
												className={classes.listItemIcon}
											>
												<Tooltip
													title={val.title}
													placement='right'
												>
													{val.icon}
												</Tooltip>
											</ListItemIcon>
											<ListItemText primary={val.title} />
										</ListItem>
									);
								}
							} else if (
								val.canBeNull === true &&
								user.userType === null
							) {
								return (
									<ListItem
										button
										key={key}
										onClick={() => {
											history.push({
												pathname: val.link,
											});
										}}
										className={
											location.pathname === val.link
												? `${styles.active} ${styles.listItem}`
												: `${styles.listItem}`
										}
									>
										<ListItemIcon>{val.icon}</ListItemIcon>
										<ListItemText primary={val.title} />
									</ListItem>
								);
							}
						})}
						<ListItem
							button
							key={'Log Out'}
							onClick={() => {
								console.log('loging out');
								proceedLogOut();
								getProfileSuccess({
									profileInfo: {},
								});

								localStorage.clear();

								signInSuccess({
									userInfo: {
										displayName: '',
										email: '',
										phoneNumber: '',
										photoURL: '',
										uid: '',
									},
									userType: '',
								});
								setRedirect(false);
								// window.location.pathname = '/signin';
							}}
							className={styles.listItemSignOut}
						>
							<ListItemIcon className={classes.listItemIcon}>
								<Tooltip title='Log Out' placement='right'>
									<ExitToAppIcon />
								</Tooltip>
							</ListItemIcon>
							<ListItemText
								className={styles.logOutText}
								primary={'Log Out'}
							/>
						</ListItem>
					</List>
				</Drawer>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
	profileData: state.profile.profileInfo,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	signInSuccess,
	setRedirect,
	proceedLogOut,
	getProfileSuccess,
	getPurchasers,
})(withRouter(Sidebar));
